import React from 'react';

import { normalizeMultiSelectValue } from '@gogame/components';
import { Filter } from '@gogame/filters';

import HomeDashboardPresetPicker from 'scenes/HomeDashboard/components/HomeDashboardPresetPicker';
import {
  FILTER_PRESETS,
  FILTER_PERIOD,
  PERIOD_PRESETS,
} from 'scenes/HomeDashboard/constants';
import * as filtersSource from 'scenes/HomeDashboard/sources/filters';
import { widgetNames } from 'scenes/HomeDashboard/widgets';

const loadPresets = () => {
  return filtersSource.loadPresets({
    keys: widgetNames,
  });
};

export const Presets = (props) => {
  return (
    <Filter
      title={'Presets'}
      source={loadPresets}
      name={FILTER_PRESETS}
      placeholder={'Select Preset'}
      primaryFilterWidth={228}
      normalizeValue={normalizeMultiSelectValue}
      refetchOnOpen={true}
      renderComponent={({
        label,
        value,
        loading,
        options,
        onChange,
        onFocus,
      }) => {
        return (
          <HomeDashboardPresetPicker
            data-cy={FILTER_PRESETS}
            loading={loading}
            options={options}
            // onOpen={() => {
            //   // area.reload();
            // }}
            label={label}
            value={value}
            onChange={onChange}
            onFocus={onFocus}
            {...props}
          />
        );
      }}
    />
  );
};

export const Period = (props) => {
  return (
    <Filter.DateRangePicker
      title={'Period'}
      presets={PERIOD_PRESETS}
      placeholder={"Preset's period"}
      name={FILTER_PERIOD}
      maxDate={new Date()}
      {...props}
    />
  );
};
